import React from 'react';
import { TheFooter, TheHeader } from './index';
import { AuthUser } from '@aws-amplify/auth';
const ErrorPage = React.lazy(() => import('../views/err/errorPage'));
interface IProps {
  auth: {
    user: AuthUser | null;
    isAuthenticated: boolean;
  };
}
const TheErrorLayout: React.FC<IProps> = (props) => {
  return (
    <div className="c-app c-default-layout">
      <div className="c-wrapper">
        <TheHeader />
        <div className="c-body">
          <main className="c-main">
            <ErrorPage />
          </main>
        </div>
        <TheFooter />
      </div>
    </div>
  );
};

export default TheErrorLayout;
